export const openedRegistCountrySet = new Set([
  "VN",
  "JP",
  "MY",
  "TH",
  "ID",
  "AU",
  "RU",
  "KR",
  "EG",
  "IL",
  "AE",
  "SA",
  "SG",
  "TR",
  "US",
  "GB",
  "FR",
  "IT",
  "ES",
  "CA",
  "DE",
  "PH",
  "PL",
  "CZ",
  "IE",
  "AT",
  "SE",
  "BE",
  "NL",
  "FI",
  "PT",
  "GR",
  "DK",
  "NZ",
  "KW",
  "QA",
  "BR",
  "KH",
  "RO",
  "HU",
  "UA",
  "NO",
  "CH",
  "ZA",
  "MA",
  "MX",
  "CL",
  "PE",
  "EC",
  "CO"
]);
const GUIDELINES_AID = "6685586866860720134";
const DSA_AID = "893639991572679936";
const JAPAN_PROGRAM_ID = "126830102569224149";
const JAPAN_PAYMENT_ID = "455973513701112375";
const INDONESIA_PROGRAM_ID = "29307818232123333";
const INDONESIA_PAYMENT_ID = "621758377890887146";
const ALL_REGIONS_PROGRAM_ID = "162154389249627213";
const ALL_REGIONS_PAYMENT_ID = "140760470502893173";
const commonAgreementIds = {
  program: ALL_REGIONS_PROGRAM_ID,
  payment: ALL_REGIONS_PAYMENT_ID,
  guidelines: GUIDELINES_AID,
  dsa: DSA_AID
};

/**
 * 有通用规则的欧洲国家
 */
const commonEuCountryInfo = [
  {
    country: "PL", // 波兰
    extra_currecy: ["PLN"] // 特定币种
  },
  {
    country: "CZ" // 捷克
    // CZK 下游还没ready，得走排期开
    // extra_currecy: ['CZK'],
  },
  {
    country: "IE" // 爱尔兰
  },
  {
    country: "AT" // 奥地利
  },
  {
    country: "SE", // 瑞典
    extra_currecy: ["SEK"]
  },
  {
    country: "BE" // 比利时
  },
  {
    country: "NL" // 荷兰
  },
  {
    country: "FI" // 芬兰
  },
  {
    country: "PT" // 葡萄牙
  },
  {
    country: "GR" // 希腊
  },
  {
    country: "DK", // 丹麦
    extra_currecy: ["DKK"]
  },
  {
    country: "RO", // 罗马尼亚 | Romania
    extra_currecy: ["RON"]
  },
  {
    country: "HU", // 匈牙利 | Hungary
    extra_currecy: ["HUF"]
  },
  {
    country: "UA", // 乌克兰 | Ukraine
    extra_currecy: ["UAH"]
  },
  {
    country: "NO", // 挪威 ｜ Norway
    extra_currecy: ["NOK"]
  },
  {
    country: "CH", // 瑞士 ｜ Switzerland
    extra_currecy: ["CHF"]
  }
];

const commonEUCountryListAccount = commonEuCountryInfo.map(item => {
  const { country, extra_currecy = [] } = item;
  return {
    country,
    currency: [...extra_currecy, "EUR", "GBP", "USD"]
  };
});

type CountryInfo = {
  country: string;
  currency: string[];
  agreement_i18n?: string;
  agreement_ids?: {
    program: string;
    payment: string;
    guidelines: string;
    dsa: string;
  };
  aid?: string[];
};

const whiteAccountCountryArr: CountryInfo[] = [
  {
    country: "VN",
    currency: ["VND", "USD"]
  },
  {
    country: "KR",
    currency: ["KRW", "USD"]
  },
  {
    country: "AE",
    currency: ["AED", "USD"]
  },
  {
    country: "EG",
    currency: ["EGP", "USD"]
  },
  {
    country: "SA",
    currency: ["SAR", "USD"]
  },
  {
    country: "SG",
    currency: ["SGD", "USD"]
  },
  {
    country: "RU",
    currency: ["RUB"]
  },
  {
    country: "ID",
    currency: ["IDR", "USD"],
    agreement_i18n: "self_register_agreement_common_new",
    agreement_ids: {
      program: INDONESIA_PROGRAM_ID,
      payment: INDONESIA_PAYMENT_ID,
      guidelines: GUIDELINES_AID,
      dsa: DSA_AID
    }
  },
  {
    country: "TH",
    currency: ["THB", "USD"]
  },
  {
    country: "MY",
    currency: ["MYR", "USD"]
  },
  {
    country: "JP",
    currency: ["JPY", "USD"],
    agreement_i18n: "self_register_agreement_common_new",
    agreement_ids: {
      program: JAPAN_PROGRAM_ID,
      payment: JAPAN_PAYMENT_ID,
      guidelines: GUIDELINES_AID,
      dsa: DSA_AID
    }
  },
  {
    country: "TR",
    currency: ["TRY", "USD"]
  },
  {
    country: "IL",
    currency: ["USD"]
  },
  {
    country: "AU",
    currency: ["AUD", "USD", "GBP"]
  },
  {
    country: "US", // 美国
    currency: ["USD", "EUR", "GBP"]
  },
  {
    country: "GB", // 英国
    currency: ["GBP"]
  },
  {
    country: "FR", // 法国
    currency: ["EUR", "USD", "GBP"]
  },
  {
    country: "IT", // 意大利
    currency: ["EUR", "USD", "GBP"]
  },
  {
    country: "ES", // 西班牙
    currency: ["EUR", "USD", "GBP"]
  },
  {
    country: "DE", // 德国
    currency: ["EUR", "USD", "GBP"]
  },
  {
    country: "CA", // 加拿大
    currency: ["CAD", "USD"]
  },
  {
    country: "PH", // 菲律宾
    currency: ["PHP", "USD"]
  },
  {
    country: "NZ", // 新西兰
    currency: ["NZD", "USD", "GBP"]
  },
  {
    country: "KW", // 科威特
    currency: ["KWD", "USD"]
  },
  {
    country: "QA", // 卡塔尔
    currency: ["QAR", "USD"]
  },
  {
    country: "BR", // 巴西 | Brazil
    currency: ["BRL"],
    aid_lang: "pt" // 对下方的条款文章有不同的语言，巴西用的是葡萄牙语言
  },
  {
    country: "KH", // 柬埔寨 | Cambodia
    currency: ["KHR", "USD"]
  },
  {
    country: "ZA", // 南非 | South Africa
    currency: ["ZAR", "USD"]
  },
  {
    country: "MA", // 摩洛哥 | Morocco
    currency: ["MAD", "USD"]
  },
  {
    country: "MX", // 墨西哥 | Mexico
    currency: ["MXN", "USD"]
  },
  {
    country: "CL", // 智利 | Chile
    currency: ["CLP", "USD"]
  },
  {
    country: 'PE', // 秘鲁 | Peru 
    currency: ['PEN', 'USD'],
  },
  {
    country: 'EC', // 厄瓜多尔 | Ecuador
    currency: ['USD'],
  },
  {
    country: 'CO', // 哥伦比亚 / Colombia
    currency: ['COP', 'USD'],
  },
  ...commonEUCountryListAccount
].map((item: any) => {
  const { agreement_i18n, agreement_ids, aid_lang } = item;
  const aids = agreement_ids || commonAgreementIds;
  return {
    ...item,
    agreement_i18n: agreement_i18n || "self_register_agreement_common_new",
    agreement_ids: aids,
    aid: [aids.program, aids.payment, aids.guidelines, aids.dsa],
    aid_lang
  };
});

export const backfillFormKeys = {
  leaveInfo: ["company", "country", "email", "phonenumber"]
};

export const whiteAccountCountry = whiteAccountCountryArr.reduce(
  (total, item) => {
    total[item.country] = item;
    return total;
  },
  {} as Record<string, CountryInfo>
);

// 国家列表中下掉的国家
export const filterCountryList = [
  "IR",
  "CU",
  "KP",
  "MM",
  "CI",
  "CU",
  "CD",
  "IR",
  "LR",
  "KP",
  "SD",
  "SY",
  "ZW"
];

export const TimezoneForCountryMap = {
  IN: "Asia/Kolkata",
  VN: "Asia/Ho_Chi_Minh",
  KR: "Asia/Seoul",
  AE: "Asia/Dubai",
  EG: "Africa/Cairo",
  SA: "Asia/Riyadh",
  SG: "Asia/Singapore",
  TW: "Asia/Taipei",
  RU: "Europe/Moscow",
  ID: "Asia/Jakarta",
  TH: "Asia/Bangkok",
  MY: "Asia/Kuala_Lumpur",
  JP: "Asia/Tokyo",
  TR: "Europe/Istanbul",
  AU: "Australia/Sydney",
  IL: "Asia/Jerusalem",
  US: "America/New_York", // 冬夏令时，对应Etc/GMT+5
  GB: "Europe/London", // 冬夏令时，对应Etc/GMT
  FR: "Europe/Paris", // 冬夏令时，对应Etc/GMT-1
  IT: "Europe/Rome", // 冬夏令时， Etc/GMT-1
  ES: "Europe/Madrid", // 冬夏令时， Etc/GMT-1
  DE: "Europe/Berlin", // 冬夏令时， Etc/GMT-1
  CA: "America/Toronto",
  PH: "Asia/Manila",
  PL: "Europe/Warsaw",
  CZ: "Europe/Prague",
  IE: "Europe/Dublin",
  AT: "Europe/Vienna",
  SE: "Europe/Stockholm",
  BE: "Europe/Brussels",
  NL: "Europe/Amsterdam",
  FI: "Europe/Helsinki",
  PT: "Europe/Lisbon",
  GR: "Europe/Athens",
  DK: "Europe/Copenhagen",
  NZ: "Pacific/Auckland",
  KW: "Asia/Kuwait",
  QA: "Asia/Qatar",
  BR: "America/Sao_Paulo",
  KH: "Asia/Phnom_Penh",
  RO: "Europe/Bucharest",
  HU: "Europe/Budapest",
  UA: "Europe/Kiev",
  NO: "Europe/Oslo",
  CH: "Europe/Zurich",
  ZA: "Africa/Johannesburg",
  MA: "Africa/Casablanca",
  MX: "America/Mexico_City",
  CL: "America/Santiago",
  PE: 'America/Lima',
  EC: 'America/Guayaquil',
  CO: 'America/Bogota'
};
